import * as types from './mutation-types'

const state = {
  signup: {
    email: '',
    password: '',
    name: ''
  }
}
const getters = {}

const actions = {
  async [types.SET_SIGNUP](payload) {
    console.log('types.set_signup', payload)
  }
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
